export const initialPrintState = (): PrintState => ({
  connected: false,
});
